<template lang="">
  <div class="justify-content-center">
    <ToastPrime />

    <div class="justify-content-center m-5">
      <img src="@/assets/logo.png" @click="home()" class="logo m-2" />
    </div>
    <div v-if="header == 'Sign In'" id="outer">
      <h1 class="text-center">{{ $t("loggingComponentHeader1") }}</h1>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <h4 class="field">{{ $t("email") }}</h4>
          <InputTextPrime class="field" v-model="email" style="width: 100%" type="email" />
          <h4 class="field">{{ $t("password") }}</h4>
          <InputTextPrime class="field" v-model="password" style="width: 100%" type="password" />
        </template>
        <template #footer>
          <ButtonPrime class="p-button-success p-2" style="width: 100%" @click="setUser" :label="header" />
        </template>
      </CardPrime>
      <div class="p-4"></div>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <p>
            {{ $t("loggingText1_1") }} <a class="text-blue-400" @click="createUser()">{{ $t("loggingText2_1") }}</a>
          </p>
        </template>
      </CardPrime>
    </div>
    <div v-if="header == 'Sign Up'" id="outer">
      <h1 class="text-center">{{ $t("loggingComponentHeader2") }}</h1>
      <CardPrime style="width: 50rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <div class="formgrid grid">
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("firstName") }}</h4>
              <InputTextPrime class="field" v-model="firstName" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("lastName") }}</h4>
              <InputTextPrime class="field" v-model="lastName" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("company") }}</h4>
              <InputTextPrime class="field" v-model="company" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("charge") }}</h4>
              <InputTextPrime class="field" v-model="charge" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("sector") }}</h4>
              <InputTextPrime class="field" v-model="sector" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("email") }}</h4>
              <InputTextPrime class="field" v-model="email" style="width: 100%" type="email" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("password") }}</h4>
              <InputTextPrime class="field" v-model="password" style="width: 100%" type="password" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("password2") }}</h4>
              <InputTextPrime class="field" v-model="confirmPassword" style="width: 100%" type="password" />
            </div>
          </div>
        </template>
        <template #footer>
          <ButtonPrime class="p-button-success p-2" style="width: 100%" @click="setUser" :label="header" />
        </template>
      </CardPrime>
      <div class="p-4"></div>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <p>
            {{ $t("loggingText1_2") }}<a class="text-blue-400" @click="createUser()">{{ $t("loggingText2_2") }}</a>
          </p>
        </template>
      </CardPrime>
    </div>
  </div>
</template>
<script>
import UserService from "@/services/UserService";
import { required, email, minLength, sameAs } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { ToastSeverity } from "primevue/api";

export default {
  data() {
    return {
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      sector: "",
      company: "",
      charge: "",
      reveal: false,
      signUp: true,
      header: "Sign In",
      users: [],
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      email: { required, email },
      firstName: { required },
      lastName: { required },
      sector: { required },
      company: { required },
      charge: { required },
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, minLength: minLength(6), sameAs: sameAs(this.password) },
    };
  },
  computed: {},
  created() {
    console.log("Logging - created");
    this.userService = UserService.getInstance();
    this.userService.getUsers(this.users);
  },
  mounted() {},
  methods: {
    async setUser() {
      console.log("Logging - setUser", this.signUp);
      if (this.header == "Sign Up") {
        const result = await this.v$.$validate();

        if (!result) {
          this.v$.$errors.forEach((error) => {
            const errorMessage = error.$property + ": " + error.$message;
            this.addErrorByToast(errorMessage);
          });
        } else {
          if (this.userService.emailVerification(this.email)) {
            this.userService.signIn(this.signUp, {
              email: this.email,
              password: this.password,
              firstName: this.firstName,
              lastName: this.lastName,
              sector: this.sector,
              company: this.company,
              charge: this.charge,
            });
          } else {
            this.addErrorByToast("ERROR. Ya existe usuario con ese email");
          }
        }
      } else {
        this.userService.signIn(this.signUp, { email: this.email, password: this.password });
      }
    },
    addErrorByToast(errorMsg) {
      this.$toast.add({
        severity: ToastSeverity.ERROR,
        closable: true,
        summary: errorMsg,
        life: 3000,
      });
    },
    createUser() {
      if (this.signUp) {
        this.header = "Sign Up";
        this.signUp = false;
      } else {
        this.header = "Sign In";
        this.signUp = true;
      }
    },
  },
};
</script>
<style>
.logo {
  width: 5%;
  height: 5%;
}
#inner {
  display: table;
  margin: 0 auto !important;
}
#outer {
  width: 100%;
}
.field {
  margin-bottom: 10px !important;
}
</style>
